












































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Lobby from './components/Lobby.vue';
import Map from './components/Map/Map.vue';
import ModalWindow from './components/ModalWindow/ModalWindow.vue';
import Prepare from './components/Game/Prepare.vue';
import UserSide from './components/UI/UserSide.vue';
import DeckSide from './components/UI/DeckSide.vue';
import PlayerSide from './components/UI/PlayerSide.vue';
import Chat from './components/chat/Chat.vue';
import Storage from './components/localStorage/storage';
import userInterface from './components/interface/user';
import taskInterface from './components/interface/taskInterface';
import playSound from './utils/sounds';

@Component({
  components: {
    Lobby,
    Map,
    ModalWindow,
    Prepare,
    UserSide,
    DeckSide,
    PlayerSide,
    Chat,
  },

  computed: {
    ...mapGetters([
      'getUsers',
      'getColors',
      'getRailways',
      'getGameStatus',
      'getTurn',
      'getCurrentName',
    ]),
  },

  methods: {},

  watch: {},
})
export default class App extends Vue {
  getCurrentName!: string;

  getTurn!: number;

  getGameStatus!: boolean;

  prepareTimer = 180;

  showModal = true;

  getUsers!: userInterface[];

  storage = new Storage();

  visibleCities: string[] = [];

  @Watch('getTurn') onTurnChange(): void {
    if (this.getTurn === -1) {
      this.prepareTimer = 180;
      this.showModal = true;
    }
    playSound('gameTurn');
  }

  get currentUser(): userInterface {
    return this.getUsers.filter((user) => user.name === this.getCurrentName)[0];
  }

  get checkUserInPlayerList(): boolean {
    return this.getUsers.includes(this.currentUser);
  }

  created(): void {
    if (this.storage.data.name) this.$store.commit('setCurrentName', this.storage.data.name);
    if (this.storage.data.color) this.$store.commit('setCurrentColor', this.storage.data.color);
    this.$socket.emit('setId', this.storage.data.name);
  }

  addUser(name: string, usedColors: string[]): void {
    const user = {
      name,
      ready: false,
    };
    this.$store.commit('setCurrentName', name);
    this.$socket.emit('setUsers', user, usedColors);
  }

  toggleStatus(name: string): void {
    this.$socket.emit('changeStatus', name);
  }

  setColor(name: string, color: string): void {
    this.$socket.emit('setNewColor', {
      name,
      color,
    });
  }

  discardRoute(array: taskInterface[]): void {
    array.forEach((route) => {
      // if (route === 'long') this.$socket.emit('discardLongRoute', this.getCurrentName);
      this.$socket.emit('discardRoute', this.getCurrentName, route);
    });
    this.$socket.emit('userPrepared', this.getCurrentName);
  }

  showCities(cities: string[]): void {
    this.visibleCities = cities;
  }

  hideCities(): void {
    this.visibleCities = [];
  }
}
